import { tituloEstado } from "../../../../utils/tituloEstado";
import { AdvisorShare, GiftRow, MonthStrip, PromoApplicationDetail, PromoApplicationRow, STATUS_ANULADA } from "./interfaces";

/* Formato compartido por la lista y las ventanas de detalle de Promociones. */

export const fecha = (d: string | null | undefined) => d ? d.slice(8, 10) + "/" + d.slice(5, 7) + "/" + d.slice(0, 4) : "";
const num = (n: number | null | undefined) => (Math.round((Number(n) || 0) * 100) / 100).toLocaleString("es-MX", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
/** Monto con el símbolo del plantel: «$1,200.00» en pesos, «L 1,200.00» en lempiras. */
export const monto = (sym: string, n: number | null | undefined) => (/^[A-Za-z]/.test(sym) ? sym + " " : sym) + num(n);
/** Primer nombre y primer apellido: «Andrea Guardado» (una asesora por renglón, como en Matrículas). */
export const nombreCorto = (n: string) => {
	const p = (n || "").trim().split(/\s+/);
	return p.length <= 2 ? p.join(" ") : p[0] + " " + p[p.length - 2];
};
/** El porcentaje va pegado al apellido (espacios duros): si el nombre no cabe, baja junto, nunca se corta. */
export const conPorcentaje = (a: AdvisorShare) => a.name + (a.sharePercentage != null ? "\u00a0" + Number(a.sharePercentage) + "\u00a0%" : "");

/** Qué parte de lo cobrado se regaló: «34 %». */
export const porcentajeRegalado = (cobrado: number, regalado: number): string => cobrado > 0.004 ? Math.round((regalado / cobrado) * 100) + " %" : "-";

export const tira = (t: MonthStrip | null | undefined) => (t?.months || []).map((m) => ({ n: m.n, title: m.title, state: m.state, subTotal: m.subTotal, list: m.listAmount }));

/** Pastilla de estado de una aplicada: Aplicada en naranja, Anulada en oro (verde solo es Matriculado). */
export const estadoAplicada = (r: { statusId: number; status?: string | null }): { texto: string; bg: string } =>
	r.statusId === STATUS_ANULADA ? { texto: tituloEstado(r.status) || "Anulada", bg: "oro" } : { texto: tituloEstado(r.status) || "Aplicada", bg: "primary" };

const ENTREGA: Record<number, string> = { 0: "Sin Dato", 1: "Sin Entregar", 2: "Entrega Parcial", 3: "Entregado" };
export const entregaDe = (g: GiftRow): string => {
	if (g.cancelled) return "Anulado";
	if (typeof g.deliveryStatus === "number") return ENTREGA[g.deliveryStatus] || "Sin Entregar";
	return tituloEstado(g.deliveryStatus || g.delivery || "") || "Sin Entregar";
};
export const entregado = (g: GiftRow) => g.cancelled || entregaDe(g) === "Entregado";

/** Los productos que regaló: `gifts` (nuevo) o, de un servidor viejo, el único kit. */
export const regalosDe = (r: PromoApplicationRow & { kit?: PromoApplicationDetail["kit"] }): GiftRow[] => {
	if (Array.isArray(r.gifts) && r.gifts.length) return r.gifts;
	if (r.kit) return [{ owedArticleId: r.kit.id, name: r.kit.name, quantity: 1, value: r.kit.value ?? null, delivery: r.kit.delivery || null, deliveredAt: r.kit.deliveredAt || null, cancelled: r.kit.cancelled }];
	if (r.giftKit) return [{ name: r.giftKit.name, quantity: 1, delivery: r.giftKit.delivery || null, cancelled: r.giftKit.cancelled }];
	return [];
};
export const nombreRegalo = (g: GiftRow) => (Number(g.quantity) > 1 ? g.quantity + " × " : "") + g.name;
export const faltanDeEntregar = (r: PromoApplicationRow) => regalosDe(r).filter((g) => !entregado(g));

/** «Mensualidad Septiembre» → «Sep»; lo que no es un mes se queda como viene. */
const MES3: Record<string, string> = { enero: "Ene", febrero: "Feb", marzo: "Mar", abril: "Abr", mayo: "May", junio: "Jun", julio: "Jul", agosto: "Ago", septiembre: "Sep", setiembre: "Sep", octubre: "Oct", noviembre: "Nov", diciembre: "Dic" };
const mesCorto = (t: string) => {
	const sin = t.replace(/^\s*mensualidad\s+/i, "").trim();
	return MES3[sin.toLowerCase()] || sin;
};

/** Lo que regaló, corto: meses (o el curso regalado) y productos. */
export const queRegalo = (d: PromoApplicationDetail): string => {
	const partes: string[] = [];
	const meses = (d.giftMonths?.months?.length ? d.giftMonths.months : d.months?.months || [])
		.filter((m) => ["gratis", "liberado", "regalo"].includes(String(m.state).toLowerCase())).map((m) => mesCorto(m.title || "Mes " + m.n));
	if (meses.length) partes.push(meses.join(", "));
	else if (d.giftEnrollmentId) partes.push("Curso" + (d.giftStudent?.name ? " a " + d.giftStudent.name : ""));
	regalosDe(d).forEach((g) => partes.push(nombreRegalo(g)));
	return partes.join(" + ");
};
